import React from "react";
import { Link } from "react-router-dom";
import { FaStore } from "react-icons/fa";
import { Translate } from "react-redux-i18n";
import AdImage from "./AdImage";
import "./styles/ProductCard.css";
import { getAdDisplayImage } from "../utils/adMediaUtils";
import { AuctionExpirationLabel } from "../utils/auctionExpirationUtils";

const KIND_BADGE_CLASS = {
  1: "product-card-badge--donation",
  2: "product-card-badge--sale",
  3: "product-card-badge--exchange",
  4: "product-card-badge--rent",
  5: "product-card-badge--auction",
};

export function getKindCommerceLabel(kindCommerceId) {
  switch (kindCommerceId) {
    case 1:
      return <Translate value="donation" />;
    case 2:
      return <Translate value="sale" />;
    case 3:
      return <Translate value="exchange" />;
    case 4:
      return <Translate value="rent" />;
    case 5:
      return <Translate value="auction" />;
    default:
      return null;
  }
}

function getMetaLabel(item) {
  if (item.KindCommerceId === 4 || item.KindCommerceId === 5) {
    return item.Frequency?.Name || "";
  }
  return item.Condition?.Name || "";
}

function shouldShowPrice(item) {
  if (item.KindCommerceId === 1 || item.KindCommerceId === 3) return false;
  return item.Price !== undefined && item.Price !== null && item.Price !== "";
}

function ProductCard({
  item,
  kindCommerce,
  onClick,
  columnClass = "product-card-list__item",
  footerAction = null,
}) {
  const detailPath = `/goder/show/${item.Id}`;
  const badgeClass = KIND_BADGE_CLASS[item.KindCommerceId] || "";
  const imageSrc = getAdDisplayImage(item);
  const metaLabel = getMetaLabel(item);
  const isAuction = Number(item.KindCommerceId) === 5;
  const showPrice = shouldShowPrice(item);
  const storeName = item.Store?.Name;

  return (
    <div className={columnClass}>
      <article className="product-card">
        <Link to={detailPath} onClick={onClick} className="product-card-media">
          {imageSrc ? (
            <AdImage
              src={imageSrc}
              alt={item.Name || "Product"}
              className="product-card-img"
            />
          ) : (
            <div className="product-card-img product-card-img--placeholder" aria-hidden="true" />
          )}

          {kindCommerce && (
            <span className={`product-card-badge ${badgeClass}`}>{kindCommerce}</span>
          )}

          {isAuction && (
            <AuctionExpirationLabel
              item={item}
              className="product-card-expiration"
            />
          )}

          {showPrice && (
            <span className="product-card-price">
              <span className="product-card-price__amount">{item.Price}</span>
              {item.Currency && (
                <small className="product-card-price__currency">{item.Currency}</small>
              )}
            </span>
          )}
        </Link>

        <div className="product-card-body">
          <h3 className="product-card-title">
            <Link to={detailPath} onClick={onClick}>
              {item.Name}
            </Link>
          </h3>

          {storeName && (
            <p className="product-card-store">
              <FaStore aria-hidden="true" />
              <span>{storeName}</span>
            </p>
          )}

          <div className="product-card-meta">
            {metaLabel ? (
              <span className="product-card-meta__tag">{metaLabel}</span>
            ) : (
              <span />
            )}
            {item.CreatedAt && (
              <time className="product-card-meta__date">{item.CreatedAt}</time>
            )}
          </div>

          {footerAction && (
            <div className="product-card-footer">{footerAction}</div>
          )}
        </div>
      </article>
    </div>
  );
}

export default ProductCard;
